import * as React from "react";
import { useFormGroup } from "./use-form-group";
export function FormGroup(props) {
    var group = useFormGroup(props);
    var children = props.children(group);
    if (children instanceof Array) {
        return React.createElement(React.Fragment, null, children);
    }
    return children;
}
//# sourceMappingURL=FormGroup.js.map